// eslint-disable-next-line
import util from 'util';

import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from "redux";
import { MuiThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import './fonts/Sofia.ttf';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/luxon';
import './index.css';
import 'typeface-roboto';

import App from './App';
import BrowserList from './BrowserList';
import { Provider } from "react-redux";
import thunk from 'redux-thunk';
import rootReducer from "./reducers";
import Theme from "./Theme";
import * as Notifications from "./Notifications";
import * as Updater from "./Updater";

import * as PortalApi from './PortalApi';

// eslint-disable-next-line
import * as coreActions from './core/actions';
import * as coreSelectors from './core/selectors';
import './i18n';



// Check for incompatible browser 
if (navigator.userAgent.match(/Trident/)) {
  ReactDOM.render(<BrowserList />, document.getElementById('root'));
} else {
  /* Alternate app for migration login page */
  if (window.location.hash === "#migrate") {
    require('./migrationLoginApp');
  } else {

    /*
     * Create the redux store 
     */
    let store = createStore(rootReducer, applyMiddleware(thunk));

    /* Set the agent user session key if passed */
    let searchParams = new URLSearchParams(window.location.search);
    let agentUserSession;
    if (searchParams.has('agentUserSession')) {
      agentUserSession = searchParams.get('agentUserSession');
    }
    if (agentUserSession) {
      store.dispatch(coreActions.setAgentUserSession(agentUserSession));
    }

    /* 
     * Create the theme object 
     */
    let theme = Theme();

    /*
     * Set up the methods for the PortalApi calls and error reporting
     */
    PortalApi.setup((error, status, content) => {
      if (status === 401) {
        store.dispatch(coreActions.authenticate());
      } else {
        store.dispatch(coreActions.closeBusy());
        if (error) {
          store.dispatch(coreActions.postSnackMessage('error', error));
        } else {
          store.dispatch(coreActions.postSnackMessage('error', 'Error code ' + status));
        }
      }
    }, () => {
      return (coreSelectors.getSessionKey(store.getState()));
    });


    ReactDOM.render(
      <Provider store={store}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <MuiThemeProvider theme={theme}>
            <CssBaseline />
            <App />
          </MuiThemeProvider>
        </MuiPickersUtilsProvider>
      </Provider>,
      document.getElementById('root'));

      // if(window.location.href.includes('startQuote') && !window.location.href.includes('portalApi')) {
      //   store.dispatch(coreActions.setLoginState('quotes'));
      // }else{
        
      // }

      /* This will kick off the authentication flow */
      if(window.location.href.includes("quotes")){
        console.log("login state :: quotes");
        store.dispatch(coreActions.setLoginState('quotes'));
      }else{
        console.log(" updateUser");
        store.dispatch(coreActions.updateUser());
      }
    

    /* Gets the API version and if it is a production system */
    store.dispatch(coreActions.updateApiInfo());

    /* Start the push notification service */
    Notifications.setup(store);

    /* Start the websocket */
    Updater.setup(store);
  }

}
